import { createAction } from 'redux-act';

const ActionTypes = {

    /** 添加一个侧边栏在顶层 */
    add: createAction('$$/rightPopUps/add'),

    /** 隐藏顶层侧边栏 */
    remove: createAction('$$/rightPopUps/remove'),

    /** 一处顶层侧边栏 */
    removeHide: createAction('$$/rightPopUps/removeHide'),

    /** 一处顶层侧边栏 */
    removeAll: createAction('$$/rightPopUps/removeAll'),
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/rightPopUps/ActionTypes.ts